import { axiosInstance} from './axiosInstances'

const path = {
    enums: '/api/enums',
    approvals: '/api/approvals'
}

export default {
    enums: {
        list: () => {
            return axiosInstance.get(`${path.enums}/`)
        },
        listByNames: (params) => {
            return axiosInstance.get(`${path.enums}/list`, { params })
        },
        find: (name) => {
            return axiosInstance.get(`${path.enums}/${name}`)
        },
    },

    approvals: {
        create: (body) => {
            return axiosInstance.post(`${path.approvals}/`, body)
        },
        list: (params) => {
            return axiosInstance.get(`${path.approvals}/`, { params: params })
        },
        getApproval: (token) => {
            return axiosInstance.get(`${path.approvals}/${token}`)
        },
        delete: (id) => {
            return axiosInstance.delete(`${path.approvals}/${id}`)
        },
        update: (token, body) => {
            return axiosInstance.put(`${path.approvals}/${token}`, body)
        },
    },
}